// extracted by css-extract-rspack-plugin
export default {"container":"container--HHiK6tQALGo04fdf","scrolling":"scrolling--V6HFXQ5LcGQCIQv6"};